module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/phone-wrap-ring.57ef5960.png";